import global from '../patterns/global-variables';
import $ from 'jquery';
window.jQuery = $;
import './vendor/jquery.validate.min.js';
import modal from '../patterns/modal.js';
import utils from '../patterns/utils.js';
import PL_utils from '../patterns/pl-utils.js';


const body = document.querySelector('body');
const modalOpts = {
    enableBackdropClose: true
};

export default () => {
    $('#verify-email-form').validate({
        onkeyup: false,
        rules: {
            'agreement-chk': {
                required: true,
            },
            'signature': {
                required: true,
            }
        },
        showErrors: function (errorMap, errorList) {
            // The arguments in errorList contain only those elements currently validated.
            // Refer to the form.successList for all the valid field,
            // and remove the error message that's associated to it.
            // Ref: https://jqueryvalidation.org/validate/  => showErrors
            this.successList.forEach((e) => {
                const targetName = e.name;
                const targetElements = $(`[name='${targetName}']`);
                const errorElement = $(`#${targetName}-label .form-error`);

                targetElements.removeClass('error');
                errorElement.addClass('hidden');
            });

            errorList.forEach((error) => {
                const targetName = error.element.name;
                const { method } = error;
                const targetElements = $(`[name='${targetName}']`);
                const errorElement = $(`#${targetName}-label .form-error`);

                targetElements.addClass('error');
                errorElement.removeClass('hidden');

                window.dataLayer.push({ 'event': 'Form_Error', 'Form_Name': 'Verify Email', 'Form_Field': targetName, 'Form_Field_Error': errorElement.text(), });

                targetElements.attr('aria-invalid', 'true');
            });
        },
        submitHandler: function (form) {
            utils.setButtonLoadingState('#verify-email-submit', '#verify-email-submit-loading', true);

            const formData = $(form).serializeArray();
            const postData = { 'anonymousToken': utils.getAnonymousToken(), token: utils.getParam('token') };

            formData.forEach(function (field) {
              postData[field.name] = field.value;
            });

            //Submit the form
            $.ajax(global.API_ENDPOINT() + '/user/confirm-email_v2', {
                data: JSON.stringify(postData),
                dataType: 'json',
                method: 'POST',
                xhrFields: {
                    withCredentials: true,
                }
            })
            .done(function (resp) {
                if (resp.success) {
                    window.dataLayer.push({ 'event': 'Form_Success', 'Form_Name': 'Sign Up', });
                    utils.setCookie('csrfToken', resp.data.csrfToken, { SameSite: 'Strict' });
                    window.location.pathname = "/listings";
                } else {
                    console.error(JSON.stringify(resp));
                    window.location.href = '/server-error';
                }
            })
            .fail(function (err) {
                console.error(JSON.stringify(err));
                window.location.href = '/server-error';
            })
            .always(() => {
                utils.setButtonLoadingState('#verify-email-submit', '#verify-email-submit-loading', false);
            });
        },
        invalidHandler: function(form, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
              validator.errorList[0].element.focus();
            }
          }
    });
}
